export const downloadAttachment = async fileMetadata => {
  try {
    const response = await fetch(fileMetadata.url);
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    const extension = `.${fileMetadata.extension}`;
    const filename = fileMetadata.name.endsWith(extension) ? fileMetadata.name : `${fileMetadata.name}${extension}`;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error('Download failed:', error);
    window.open(fileMetadata.url, '_blank');
  }
};